import React, { useEffect, useState, useCallback, useRef } from "react";
import { Dropdown, Modal, Button, Tabs, Tab, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Formik, Field, Form as FormikForm, ErrorMessage } from "formik";
import * as Yup from "yup";
import * as XLSX from "xlsx";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import Spinner from "../components/Common/Spinner";
import {
  addFile,
  createNewAdmin,
  deleteAdmin,
  deleteAds,
  getUrl,
  updateAdminInfo,
  updateAdminStatus,
  updateListingStatus,
  vendorRequest,
} from "../../services/Admin/adminServices";
import Pagination from "../components/Pagination";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserList2 } from "../../services/UserServices/UserService";
import "react-phone-input-2/lib/style.css";
import { useSearchParams } from "react-router-dom";
import {
  addAdsLimit,
  getFlatList,
  getWaitList,
  getAdsExportList,
} from "../../services/UserServices/UserService";
import { set } from "lodash";
import LocationSearchDropdown from "../components/LocationAdd";

const ReadMoreText = ({ text, maxLength = 30, maxWidth = "220px" }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!text) return "_";

  const textStr = typeof text === "string" ? text : String(text);
  const formattedText = textStr.charAt(0).toUpperCase() + textStr.slice(1);

  if (formattedText.length <= maxLength) {
    return <span style={{ whiteSpace: "normal", wordBreak: "break-word" }}>{formattedText}</span>;
  }

  return (
    <div style={{ maxWidth: isExpanded ? "350px" : maxWidth, wordBreak: "break-word", whiteSpace: "normal" }}>
      {isExpanded ? formattedText : `${formattedText.slice(0, maxLength)}...`}
      <button
        type="button"
        className="btn btn-link p-0 text-primary fw-semibold ms-1"
        style={{ fontSize: "12px", textDecoration: "none", boxShadow: "none", verticalAlign: "baseline" }}
        onClick={(e) => {
          e.stopPropagation();
          setIsExpanded(!isExpanded);
        }}
      >
        {isExpanded ? "Read Less" : "Read More"}
      </button>
    </div>
  );
};

const Listing = () => {
  const [admins, setAdmins] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const page = searchParams.get("page");

  const [locationText, setLocationText] = useState(
    location.state?.locationText || ""
  );
  const [search, setSearch] = useState(
    location.state?.search || {
      lat: "",
      long: "",
    }
  );
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const roleData = useSelector((state) => state.role.roles);
  const [startDate, setStartDate] = useState(
    location.state?.startDate || ""
  );
  const [endDate, setEndDate] = useState(
    location.state?.endDate || ""
  );

  const [currentPage, setCurrentPage] = useState(
    location.state?.currentPage ?? 0
  );
  const [itemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [activeTab, setActiveTab] = useState(
    location.state?.activeTab || "User"
  );
  const [type, setType] = useState(
    location.state?.type || ""
  );
  const [limitModal, setLimitModal] = useState(false);
  const [adsLimit, setAdsLimit] = useState("");
  const [user, setUser] = useState(
    location.state?.user || ""
  ); // Selected User Object or ID
  const [usersList, setUsersList] = useState([]); // List of users loaded
  const [userSearch, setUserSearch] = useState(""); // Search input for user dropdown
  const [usersPage, setUsersPage] = useState(0); // Infinite scroll page tracker
  const [usersLoading, setUsersLoading] = useState(false);
  const [hasMoreUsers, setHasMoreUsers] = useState(true);
  const [expiry, setExpiry] = useState(
    location.state?.expiry || ""
  );
  const [showExportModal, setShowExportModal] = useState(false);
  const [exportType, setExportType] = useState("excel");
  const [exportStartDate, setExportStartDate] = useState("");
  const [exportEndDate, setExportEndDate] = useState("");
  const [exportLocationText, setExportLocationText] = useState("");
  const [exportCoordinates, setExportCoordinates] = useState({ lat: "", long: "" });
  const [exportLoading, setExportLoading] = useState(false);
  // 🌟 Added state for the Confirmation Modal
  const [confirmState, setConfirmState] = useState({
    show: false,
    action: null,
    id: null,
    status: null,
    message: "",
  });
  const navigate = useNavigate();
  const [rejectReason, setRejectReason] = useState("");
  const [adType, setAdType] = useState(
    location.state?.adType || ""
  );
  const [rentalStatus, setRentalStatus] = useState(
    location.state?.rentalStatus || ""
  );

  useEffect(() => {
    if (page !== null) {
      setCurrentPage(Number(page) || 0);
    }
  }, [searchParams]);

  useEffect(() => {
    if (currentPage !== undefined) {
      navigate(".", {
        replace: true,
        state: {
          ...location.state,
          currentPage,
          activeTab,
          type,
          adType,
          rentalStatus,
          locationText,
          search,
          startDate,
          endDate,
          expiry,
          user,
        },
      });
    }
  }, [currentPage, activeTab, type, adType, rentalStatus, locationText, search, startDate, endDate, expiry, user]);

  const isInitialMount = useRef(true);
  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }
    setCurrentPage(0);
  }, [search, startDate, endDate, type, adType, rentalStatus, expiry, user, locationText]);

  const [uploading, setUploading] = useState(false);
  const [preview, setPreview] = useState("");
  const fileInputRef = useRef(null);
  const [imageLoading, setImageLoading] = useState(false);
  const [submit, setSubmit] = useState(false);
  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="12" cy="5" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="19" r="2"></circle>
      </g>
    </svg>
  );

  const fetchUsers = useCallback(
    async (pageNum, searchStr) => {
      try {
        setUsersLoading(true);
        const response = await getUserList2(
          pageNum,
          10,
          "Verified",
          searchStr
        );

        const newUsers = response?.data?.data?.data || [];
        const totalUsers = response?.data?.data?.total || 0;

        setUsersList((prev) => {
          const updated = pageNum === 0 ? newUsers : [...prev, ...newUsers];
          setHasMoreUsers(updated.length < totalUsers);
          return updated;
        });
      } catch (error) {
        console.error("Failed to load users:", error);
      } finally {
        setUsersLoading(false);
      }
    },
    []
  );

  // Initial load of users
  useEffect(() => {
    fetchUsers(0, "");
  }, [fetchUsers]);

  // Debounced user search
  useEffect(() => {
    const timer = setTimeout(() => {
      setUsersPage(0);
      fetchUsers(0, userSearch);
    }, 300);

    return () => clearTimeout(timer);
  }, [userSearch, fetchUsers]);

  // Fetch next page of users when usersPage increments
  useEffect(() => {
    if (usersPage > 0) {
      fetchUsers(usersPage, userSearch);
    }
  }, [usersPage, userSearch, fetchUsers]);

  const handleDropdownScroll = (e) => {
    const target = e.target;
    if (target.scrollHeight - target.scrollTop <= target.clientHeight + 20) {
      if (!usersLoading && hasMoreUsers) {
        setUsersPage((prevPage) => prevPage + 1);
      }
    }
  };

  const fetchAdmins = useCallback(async () => {

    try {
      setLoading(true);
      const response = await getFlatList(
        currentPage,
        itemsPerPage,
        expiry,
        type,
        adType,
        user,
        search.lat,
        search.long,
        rentalStatus,
      );
      setAdmins(response?.data?.data?.ads || []);
      setTotalItems(response?.data?.data?.total || 0);
    } catch (error) {
      console.error(error);
      toast.error("Failed to load data");
    } finally {
      setLoading(false);
    }
  }, [currentPage, itemsPerPage, search, user, expiry, type, adType, rentalStatus]);

  useEffect(() => {
    fetchAdmins();
  }, [fetchAdmins]);


  const getUrlImage = async (img) => {
    try {
      return await getUrl(img);
    } catch (error) {
      console.error(error);
    }
  };

  const handleDelete = async (id, reason) => {
    try {
      await deleteAds(id, reason);
      toast.success("Successfully deleted");
      fetchAdmins();
      setRejectReason("");
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to delete user");
      console.error(error);
    }
  };

  const handlestatus = async (status, id) => {
    try {
      const payload = { status: status, id: id };
      if (status === "Reject") {
        payload.reason = rejectReason;
        if (rejectReason === "") {
          toast.error("Please enter a reason for rejection");
          return;
        }
      }
      await updateListingStatus(payload);
      setRejectReason("");
      toast.success("Status updated successfully");
      fetchAdmins();
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to update status");
      console.error(error);
    }
  };

  const handleFileUpload = async (e, fieldName, setFieldValue) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      setUploading(true);
      const formData = new FormData();
      formData.append("file", file);
      const res = await addFile(formData);

      if (res) {
        setPreview(URL.createObjectURL(file));
        setFieldValue("image", res?.data?.data?.fileUrl);
      }
    } catch (error) {
      toast.error("File upload failed");
      setPreview("");
    } finally {
      setUploading(false);
    }
  };

  const openModal = async (admin = null) => {
    setSelectedAdmin(admin);
    setShowModal(true);

    if (admin?.image) {
      try {
        setImageLoading(true);
        const res = await getUrlImage(admin.image);
        setPreview(res?.data?.data);
      } catch (error) {
        console.error(error);
      } finally {
        setImageLoading(false);
      }
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedAdmin(null);
    setPreview("");

    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const AdminSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    image: Yup.string().required("image is required"),
  });

  const ExportSchema = Yup.object().shape({
    startDate: Yup.string().required("Start date is required"),
    endDate: Yup.string()
      .required("End date is required")
      .test("is-after-start", "End date cannot be before start date", function (endDate) {
        const { startDate } = this.parent;
        if (!startDate || !endDate) return true;
        return new Date(endDate) >= new Date(startDate);
      }),
    adType: Yup.string(),
    expireStatus: Yup.string(),
    minPrice: Yup.number().typeError("Must be a number").nullable(),
    maxPrice: Yup.number().typeError("Must be a number").nullable(),
    furnishedType: Yup.string(),
    bedroom: Yup.string().oneOf(["", "Shared", "Private"], "Must be Shared or Private"),
    bathroom: Yup.string().oneOf(["", "Shared", "Private"], "Must be Shared or Private"),
    exportType: Yup.string(),
  });

  const openExportModal = () => {
    setExportStartDate(startDate || "");
    setExportEndDate(endDate || "");
    setExportLocationText(locationText || "");
    setExportCoordinates(search || { lat: "", long: "" });
    setShowExportModal(true);
  };

  const handleExportCSV = async (values, { setSubmitting }) => {
    try {
      setExportLoading(true);
      const res = await getAdsExportList(
        values.startDate,
        values.endDate,
        values.minPrice ?? "",
        values.maxPrice ?? "",
        values.furnishedType || "",
        values.bathroom ?? "",
        values.bedroom ?? "",
        values.adType || "",
        exportCoordinates.lat || "",
        exportCoordinates.long || "",
        values.expireStatus || ""
      );

      const rawData = res?.data?.data;
      let list = [];
      if (Array.isArray(rawData)) {
        list = rawData;
      } else if (Array.isArray(res?.data)) {
        list = res.data;
      } else if (rawData?.ads && Array.isArray(rawData.ads)) {
        list = rawData.ads;
      } else if (rawData?.data && Array.isArray(rawData.data)) {
        list = rawData.data;
      } else if (rawData?.list && Array.isArray(rawData.list)) {
        list = rawData.list;
      }

      if (!list || list.length === 0) {
        toast.error("No data found for the selected criteria");
        return;
      }

      const csvData = list.map((item) => {
        const startDate = item?.expireDate || item?.createdAt;
        const calcExpiryDate = startDate
          ? new Date(new Date(startDate).getTime() + 30 * 24 * 60 * 60 * 1000).toLocaleDateString()
          : "_";

        const expiredOn =
          item?.adminApproveStatus?.toLowerCase() === "approved"
            ? item?.isExpire
              ? item?.updatedAt
                ? new Date(item?.updatedAt).toLocaleDateString()
                : calcExpiryDate
              : startDate
                ? `${item?.remainingExpireDays ?? 0} days left (${calcExpiryDate})`
                : "_"
            : "_";

        const listingStatus = item?.isExpire ? "Expired" : "Active";

        return {
          "User Name": item.user?.name || "_",
          "User Phone": item.user?.phoneNumber
            ? `${item.user?.countryCode || ""} ${item.user?.phoneNumber}`.trim()
            : "_",
          "Title": item.title || "_",
          "Ad Type": item.adType || "_",
          "Status": item.status ? (item.status === "NotRental" ? "Available" : "Booked") : "_",
          "Listing Status": listingStatus,
          "Admin Approve Status": item.adminApproveStatus || "_",
          "Pin Code": item.pinCode || "_",
          "Monthly Rent": item.monthlyRent ?? "_",
          "Min Budget": item.minBudget ?? "_",
          "Max Budget": item.maxBudget ?? "_",
          "Security Deposit": item.securityDeposit ?? "_",
          "Setup Cost": item.setupCost ?? "_",
          "Move In Timeline": item.moveInTimeline || "_",
          "Address": item.address || "_",
          "Food Preferences": item.foodPreferences || "_",
          "Pet Friendly": item.petFriendly || "_",
          "Furnished Type": item.furnishedType || "_",
          "Room Type": item.roomType || "_",
          "Bathroom": item.bathroom || "_",
          "Move In Date": item.moveInDate
            ? new Date(item.moveInDate).toLocaleDateString()
            : "_",
          "Lease Period": item.leasePeriod || "_",
          "Roommate": item.roommate ?? "_",
          "Step Counts": item.stepCounts ?? "_",
          "Express Interest Counts": item.expressInterestCounts ?? "_",
          "Express Acceptance Counts": item.expressAcceptanceCounts ?? "_",
          "Booking Counts": item.bookingCounts ?? "_",
          "Expire Date": expiredOn,
          "Reject Reason": item.rejectReason || "_",
          "Created At": item.createdAt
            ? new Date(item.createdAt).toLocaleDateString()
            : "_",
        };
      });

      const exportFormat = values.exportType || exportType || "excel";

      if (exportFormat === "excel") {
        const worksheet = XLSX.utils.json_to_sheet(csvData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Ads");
        XLSX.writeFile(
          workbook,
          `ads_export_${values.startDate}_to_${values.endDate}.xlsx`
        );
        toast.success("Excel exported successfully");
      } else {
        const headers = Object.keys(csvData[0]);
        const csvContent = [
          headers.join(","),
          ...csvData.map((row) =>
            headers
              .map((header) => `"${String(row[header] ?? "").replace(/"/g, '""')}"`)
              .join(",")
          ),
        ].join("\n");

        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.href = url;
        link.setAttribute(
          "download",
          `ads_export_${values.startDate}_to_${values.endDate}.csv`
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

        toast.success("CSV exported successfully");
      }
      setShowExportModal(false);
    } catch (error) {
      console.error("Export Error:", error);
      toast.error(error?.response?.data?.message || "Failed to export data");
    } finally {
      setExportLoading(false);
      if (setSubmitting) setSubmitting(false);
    }
  };

  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const handleSaveLimit = async () => {
    try {
      const payload = {
        limit: Number(adsLimit),
      };

      await addAdsLimit(payload);

      toast.success("Ads limit updated successfully");
      setLimitModal(false);
      setAdsLimit("");
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Failed to update ads limit",
      );
    }
  };
  const handleSubmit = async (values, { resetForm }) => {
    try {
      setSubmit(true);
      if (selectedAdmin) {
        const payload = {
          id: selectedAdmin._id,
          name: values.name,
          image: values.image,
        };
        await updateAdminInfo(payload);
        toast.success("Updated successfully");
      } else {
        await createNewAdmin(values);
        toast.success("Added successfully");
        resetForm();
      }
      fetchAdmins();
      setShowModal(false);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to save admin");
    } finally {
      setSubmit(false);
    }
  };

  const isFilterActive =
    Boolean(search?.lat || search?.long || startDate || endDate || type || expiry || user || adType || rentalStatus || locationText);

  const handleRequest = async (status, id) => {
    try {
      const payload = {
        id: id,
        status: status,
      };
      await vendorRequest(payload);
      toast.success(`Request Successfully ${status}ed`);
      fetchAdmins();
    } catch (error) {
      console.error(error);
    }
  };

  const handleClear = () => {
    setSearch({ lat: "", long: "" });
    setStartDate("");
    setEndDate("");
    setUser("");
    setType("");
    setAdType("");
    setRentalStatus("");
    setLocationText("");
    setExpiry("");
  };

  // 🌟 Trigger Confirmation Modal
  const triggerConfirm = (action, id, status = null) => {
    let message = "";
    if (action === "delete") {
      message =
        "Are you sure you want to delete this record? This action cannot be undone.";
    } else if (action === "status") {
      message = `Are you sure you want to ${status.toLowerCase()} this account?`;
    } else if (action === "request") {
      message = `Are you sure you want to ${status.toLowerCase()} this vendor's request?`;
    }
    setConfirmState({ show: true, action, id, status, message });
  };

  const confirmActionHandler = () => {
    const { action, id, status } = confirmState;

    if (action === "delete" && !rejectReason.trim()) {
      toast.error("Please enter a reason");
      return;
    }

    if (action === "delete") {
      handleDelete(id, rejectReason);
    } else if (action === "status") {
      handlestatus(status, id, rejectReason);
    } else if (action === "request") {
      handleRequest(status, id);
    }
    setConfirmState({
      show: false,
      action: null,
      id: null,
      status: null,
      message: "",
    });
  };
  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h1 style={{ color: "#E5484D" }}>Ads Listing</h1>
        <div className="d-flex gap-2">
          <button
            onClick={openExportModal}
            className="btn btn-sm text-white d-flex align-items-center gap-2 shadow-sm px-3 py-2"
            style={{
              backgroundColor: "#E5484D",
              borderRadius: "0.5rem",
              border: "none",
            }}
          >
            Export Ads
          </button>
          <button
            onClick={() => setLimitModal(true)}
            className="btn btn-sm text-white d-flex align-items-center gap-2 shadow-sm px-3 py-2"
            style={{
              backgroundColor: "#E5484D",
              borderRadius: "0.5rem",
              border: "none",
            }}
          >
            Set Ads Limit
          </button>
        </div>
      </div>

      <div className="pb-2 d-flex flex-wrap justify-content-between gap-2 align-items-end mb-4">
        <div className="flex-grow-1" style={{ minWidth: "200px" }}>
          <label className="form-label mb-1" style={{ fontSize: "12px", color: "#6c757d" }}>
            Location
          </label>

          <LocationSearchDropdown
            value={locationText}
            onChange={setLocationText}
            onSelect={(locationData) => {
              setLocationText(locationData.name);
              const lat = locationData.location?.coordinates?.[1];
              const long = locationData.location?.coordinates?.[0];

              setSearch({ lat, long });
            }}
          />
        </div>

        <div>
          <label className="form-label mb-1" style={{ fontSize: "12px", color: "#6c757d" }}>
            Status
          </label>

          <select
            className="form-control"
            value={type}
            style={{ borderRadius: "0.5rem", borderColor: "#E5484D", height: "42px" }}
            onChange={(e) => setType(e.target.value)}
          >
            <option value="">All</option>
            <option value="Pending">Pending</option>
            <option value="Reject">Rejected</option>
            <option value="Approved">Approved</option>

          </select>
          
        </div>
        <div>
          <label className="form-label mb-1" style={{ fontSize: "12px", color: "#6c757d" }}>
            Ad Type
          </label>

          <select
            className="form-control"
            value={adType}
            style={{ borderRadius: "0.5rem", borderColor: "#E5484D", height: "42px" }}
            onChange={(e) => setAdType(e.target.value)}
          >
            <option value="">All</option>
            <option value="Flat">Flat</option>
            <option value="Flatmate">Flatmate</option>{" "}
          </select>
        </div>
        <div>
          <label className="form-label mb-1" style={{ fontSize: "12px", color: "#6c757d" }}>
            Rental Status
          </label>
          <select
            className="form-control"
            value={rentalStatus}
            style={{ borderRadius: "0.5rem", borderColor: "#E5484D", height: "42px" }}
            onChange={(e) => setRentalStatus(e.target.value)}
          >
            <option value="">All</option>
            <option value="NotRental">Available </option>
            <option value="Rental">Booked</option>
          </select>
        </div>

        <div>
          <label className="form-label mb-1" style={{ fontSize: "12px", color: "#6c757d" }}>
            Listing Status
          </label>
          <select
            className="form-control"
            value={expiry}
            style={{ borderRadius: "0.5rem", borderColor: "#E5484D", height: "42px" }}
            onChange={(e) => setExpiry(e.target.value)}
          >
            <option value="">All</option>
            <option value="active">Active</option>
            <option value="expire">Expired</option>
          </select>
        </div>
        <div>
          <label className="form-label mb-1" style={{ fontSize: "12px", color: "#6c757d" }}>
            Filter By User
          </label>
          <Dropdown>
            <Dropdown.Toggle
              variant="outline-secondary"
              id="dropdown-user-scroll"
              className="d-flex justify-content-between align-items-center w-100"
              style={{
                minWidth: "200px",
                height: "42px",
                borderRadius: "0.5rem",
                borderColor: "#E5484D",
              }}
            >
              {user
                ? usersList.find((u) => u._id === user)?.name || "User Selected"
                : "Select User"}
            </Dropdown.Toggle>

            <Dropdown.Menu
              onScroll={handleDropdownScroll}
              className="shadow-lg border-0 rounded-3 p-0"
              style={{
                maxHeight: "300px",
                overflowY: "auto",
                margin: "0px",
                width: "320px",
              }}
            >
              <div
                className="p-2 sticky-top bg-white border-bottom shadow-sm"
                onClick={(e) => e.stopPropagation()}
                style={{ zIndex: 10 }}
              >
                <div className="position-relative">
                  <input
                    type="text"
                    className="form-control form-control-sm pe-4"
                    placeholder="Search name or phone..."
                    value={userSearch}
                    onChange={(e) => setUserSearch(e.target.value)}
                    onClick={(e) => e.stopPropagation()}
                    style={{
                      borderRadius: "0.375rem",
                      fontSize: "12px",
                      borderColor: "#E5484D",
                    }}
                  />
                  {userSearch && (
                    <button
                      type="button"
                      className="btn-close position-absolute end-0 top-50 translate-middle-y me-2"
                      style={{ fontSize: "10px" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setUserSearch("");
                      }}
                    />
                  )}
                </div>
              </div>

              <Dropdown.Item
                onClick={() => setUser("")}
                className="d-flex align-items-center gap-2 py-2 px-3 border-bottom"
                style={{
                  cursor: "pointer",
                  backgroundColor: user === "" ? "#FEE2E2" : "transparent",
                  color: user === "" ? "#E5484D" : "#1F2937",
                  fontWeight: user === "" ? "600" : "500",
                }}
              >
                <div
                  className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0 fw-bold"
                  style={{
                    width: "32px",
                    height: "32px",
                    backgroundColor: user === "" ? "#E5484D" : "#E5E7EB",
                    color: user === "" ? "#FFFFFF" : "#6B7280",
                    fontSize: "12px",
                  }}
                >
                  👥
                </div>
                <div className="flex-grow-1" style={{ fontSize: "13px" }}>
                  All Users
                </div>
                {user === "" && (
                  <span className="ms-auto fw-bold" style={{ color: "#E5484D", fontSize: "14px" }}>
                    ✓
                  </span>
                )}
              </Dropdown.Item>

              {usersList.map((usr) => {
                const isSelected = user === usr._id;
                const initial = usr.name ? usr.name.charAt(0).toUpperCase() : "U";
                const fullName = usr.name ? usr.name.charAt(0).toUpperCase() + usr.name.slice(1) : "Unknown";
                const contactInfo = usr.phoneNumber
                  ? `${usr.countryCode || ""} ${usr.phoneNumber}`.trim()
                  : usr.email || "No contact";

                return (
                  <Dropdown.Item
                    key={usr._id}
                    onClick={() => setUser(usr._id)}
                    className="d-flex align-items-center gap-2 py-2 px-3 border-bottom border-light"
                    style={{
                      cursor: "pointer",
                      backgroundColor: isSelected ? "#FEE2E2" : "transparent",
                      color: isSelected ? "#E5484D" : "#1F2937",
                      whiteSpace: "normal",
                    }}
                  >
                    <div
                      className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0 fw-bold"
                      style={{
                        width: "32px",
                        height: "32px",
                        backgroundColor: isSelected ? "#E5484D" : "#F3F4F6",
                        color: isSelected ? "#FFFFFF" : "#4B5563",
                        fontSize: "13px",
                      }}
                    >
                      {initial}
                    </div>

                    <div className="flex-grow-1 overflow-hidden" style={{ lineHeight: "1.25" }}>
                      <div className="fw-semibold text-truncate" style={{ fontSize: "13px", color: isSelected ? "#E5484D" : "#111827" }}>
                        {fullName}
                      </div>
                      <div className="text-muted text-truncate" style={{ fontSize: "11px" }}>
                        {contactInfo}
                      </div>
                    </div>

                    {isSelected && (
                      <span className="ms-auto flex-shrink-0 fw-bold" style={{ color: "#E5484D", fontSize: "14px" }}>
                        ✓
                      </span>
                    )}
                  </Dropdown.Item>
                );
              })}

              {usersLoading && (
                <div className="text-center py-2 text-muted small">
                  Loading users...
                </div>
              )}

              {!usersLoading && usersList.length === 0 && (
                <div className="text-center py-2 text-muted small">
                  No users found
                </div>
              )}

              {!hasMoreUsers && usersList.length > 0 && (
                <div
                  className="text-center py-2 text-muted small"
                  style={{ fontSize: "10px" }}
                >
                  End of list
                </div>
              )}
            </Dropdown.Menu>
          </Dropdown>
        </div>

        {isFilterActive && (
          <div>
            <button
              className="btn btn-outline-danger"
              onClick={handleClear}
              style={{ borderRadius: "0.5rem", height: "42px" }}
            >
              Clear
            </button>
          </div>
        )}
      </div>

      {loading ? (
        <Spinner />
      ) : (
        <div className="table-responsive">
          <table className="table table-striped align-middle shadow-sm" style={{

            width: "100%",
          }}>
            <thead className="table-light">
              <tr>
                <th>Sr No.</th>
                <th>Flat</th>
                <th>Ad Type</th>

                <th style={{ minWidth: "240px" }}>Address</th>
                <th style={{ minWidth: "110px" }}>Status</th>
                <th>Approve Status</th>
                <th>Expired On</th>
                <th>Registered By</th>
                <th>Co-Search</th>
                <th>Registered At</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {admins?.length > 0 ? (
                admins.map((admin, index) => (
                  <tr key={admin._id || index}>
                    <td>{currentPage * itemsPerPage + index + 1}</td>
                    <td>
                      {admin.title
                        ? `${admin.title
                          .charAt(0)
                          .toUpperCase()}${admin.title.slice(1)}`
                        : "_"}
                    </td>
                    <td>{admin.adType ? admin.adType : "_"}</td>
                    <td style={{ whiteSpace: "normal", minWidth: "240px" }}>
                      <ReadMoreText text={admin.address} maxLength={30} maxWidth="220px" />
                    </td>

                    <td style={{ minWidth: "110px" }}>
                      {admin.status
                        ? admin.status === "NotRental"
                          ? "Available"
                          : "Booked"
                        : "_"}
                    </td>
                    <td className="text-center">
                      <span
                        className={`badge ${admin?.adminApproveStatus?.toLowerCase() ===
                          "approved"
                          ? "bg-success"
                          : admin?.adminApproveStatus?.toLowerCase() ===
                            "pending"
                            ? "bg-warning text-white"
                            : "bg-danger"
                          }`}
                      >
                        {admin.adminApproveStatus}
                      </span>
                    </td>


                    <td>
                      {admin?.adminApproveStatus?.toLowerCase() === "approved"
                        ? admin?.isExpire
                          ? new Date(admin?.updatedAt).toLocaleDateString()
                          : `${admin?.remainingExpireDays ?? 0} days left (${admin?.expireDate || admin?.createdAt
                            ? new Date(
                              new Date(admin?.expireDate || admin?.createdAt).getTime() +
                              30 * 24 * 60 * 60 * 1000
                            ).toLocaleDateString()
                            : "_"
                          })`
                        : "_"}
                    </td>



                    <td
                      onClick={() =>
                        roleData
                          ? (roleData?.userManagement?.isRead ||
                            roleData?.misManagement.isRead) &&
                          navigate(`/user-detail/${admin?.user?._id}`)
                          : navigate(`/user-detail/${admin?.user?._id}`, {
                            state: {
                              from: `${location.pathname}?page=${currentPage}`,
                            },
                          })
                      }
                      className="cursor-pointer"
                      style={{ color: "blue" }}
                    >
                      {admin?.user?.name.charAt(0).toUpperCase() +
                        admin?.user?.name.slice(1)}
                    </td>
                    {admin?.adType === "Flatmate" ? <td>{admin?.isCoSearch ? "Yes" : "No"}</td> : <td>_</td>}

                    <td>{new Date(admin?.createdAt).toLocaleDateString()}</td>

                    <td style={{ textAlign: "center" }}>
                      <Dropdown>
                        <Dropdown.Toggle
                          variant="light"
                          id={`dropdown-basic-${index}`}
                          style={{ padding: "4px 8px" }}
                        >
                          {svg1}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() =>
                              navigate(`/listing-detail/${admin._id}`, {
                                state: {
                                  currentPage,
                                },
                              })
                            }
                          >
                            View
                          </Dropdown.Item>

                          {roleData ? (
                            roleData?.adsManagement?.isUpdate &&
                            (admin?.adminApproveStatus?.toLowerCase() ===
                              "pending" ? (
                              <>
                                <Dropdown.Item
                                  onClick={() =>
                                    triggerConfirm(
                                      "status",
                                      admin._id,
                                      "Approved",
                                    )
                                  }
                                >
                                  Approve
                                </Dropdown.Item>
                                <Dropdown.Item
                                  onClick={() =>
                                    triggerConfirm(
                                      "status",
                                      admin._id,
                                      "Reject",
                                    )
                                  }
                                >
                                  Reject
                                </Dropdown.Item>
                              </>
                            ) : (
                              <Dropdown.Item
                                onClick={() =>
                                  triggerConfirm(
                                    "status",
                                    admin._id,
                                    admin.adminApproveStatus === "Approved"
                                      ? "Reject"
                                      : "Approved",
                                  )
                                }
                              >
                                {admin?.adminApproveStatus?.toLowerCase() ===
                                  "approved"
                                  ? "Reject"
                                  : "Approve"}
                              </Dropdown.Item>
                            ))
                          ) : admin?.adminApproveStatus?.toLowerCase() ===
                            "pending" ? (
                            <>
                              <Dropdown.Item
                                onClick={() =>
                                  triggerConfirm(
                                    "status",
                                    admin._id,
                                    "Approved",
                                  )
                                }
                              >
                                Approve
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() =>
                                  triggerConfirm("status", admin._id, "Reject")
                                }
                              >
                                Reject
                              </Dropdown.Item>
                            </>
                          ) : (
                            <Dropdown.Item
                              onClick={() =>
                                triggerConfirm(
                                  "status",
                                  admin._id,
                                  admin.adminApproveStatus === "Approved"
                                    ? "Reject"
                                    : "Approved",
                                )
                              }
                            >
                              {admin?.adminApproveStatus?.toLowerCase() ===
                                "approved"
                                ? "Reject"
                                : "Approve"}
                            </Dropdown.Item>
                          )}

                          {roleData ? (
                            roleData?.adsManagement?.isDelete && (
                              <Dropdown.Item
                                onClick={() =>
                                  triggerConfirm("delete", admin._id)
                                }
                              >
                                Delete
                              </Dropdown.Item>
                            )
                          ) : (
                            <Dropdown.Item
                              onClick={() =>
                                triggerConfirm("delete", admin._id)
                              }
                            >
                              Delete
                            </Dropdown.Item>
                          )}
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="10" className="text-center">
                    No data found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      <div className="card-footer clearfix mt-3">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center text-center text-md-start">
          <div
            className="dataTables_info fw-bold mb-3 mb-md-0"
            style={{ color: "#E5484D" }}
          >Total Ads : {totalItems}</div>
          <div className="d-flex align-items-center">
            {totalPages > 0 && (
              <Pagination
                pageCount={totalPages}
                pageValue={currentPage}
                setPage={setCurrentPage}
              />
            )}
          </div>
        </div>
      </div>

      {/* Main Edit/Add Modal */}
      <Modal size="xl" show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>{selectedAdmin ? "Edit User" : "Add User"}</Modal.Title>
        </Modal.Header>
        <Formik
          initialValues={
            selectedAdmin
              ? {
                userId: selectedAdmin._id,
                name: selectedAdmin.name || "",
                image: selectedAdmin.image || "",
              }
              : {
                name: "",
                image: "",
              }
          }
          enableReinitialize
          validationSchema={AdminSchema}
          onSubmit={handleSubmit}
        >
          {({ errors, touched, values, setFieldValue }) => (
            <FormikForm>
              <Modal.Body>
                <div className="mb-3">
                  <label className="form-label">Name</label>
                  <Field
                    name="name"
                    placeholder="ex. John Doe"
                    className={`form-control ${errors.name && touched.name ? "is-invalid" : ""
                      }`}
                  />
                  <ErrorMessage
                    name="name"
                    component="div"
                    className="text-danger"
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Image</label>
                  <input
                    type="file"
                    accept="image/*"
                    className="form-control"
                    ref={fileInputRef}
                    onChange={(e) =>
                      handleFileUpload(e, "image", setFieldValue)
                    }
                  />
                  <ErrorMessage
                    name="image"
                    component="div"
                    className="text-danger mt-1"
                  />
                </div>

                {uploading ? (
                  <div className="text-success mt-2">Uploading image...</div>
                ) : imageLoading ? (
                  <div>loading...</div>
                ) : (
                  preview && (
                    <div className="mb-3 text-center mt-3">
                      <div
                        style={{
                          display: "inline-block",
                          position: "relative",
                        }}
                      >
                        <img
                          src={preview}
                          alt="preview"
                          style={{
                            width: "120px",
                            height: "120px",
                            objectFit: "cover",
                            borderRadius: "10px",
                            border: "1px solid #ddd",
                          }}
                        />
                        <button
                          type="button"
                          className="btn btn-danger btn-sm shadow"
                          style={{
                            position: "absolute",
                            top: "-8px",
                            right: "-8px",
                            borderRadius: "50%",
                            width: "24px",
                            height: "24px",
                            padding: "0",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            lineHeight: "1",
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                          onClick={() => {
                            setPreview("");
                            if (fileInputRef.current)
                              fileInputRef.current.value = "";
                            setFieldValue("image", "");
                          }}
                        >
                          &times;
                        </button>
                      </div>
                    </div>
                  )
                )}
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseModal}>
                  Close
                </Button>
                <Button
                  type="submit"
                  style={{ backgroundColor: " #FFE4E6", border: "none" }}
                  disabled={uploading}
                >
                  {submit ? "Saving" : "Save Changes"}
                </Button>
              </Modal.Footer>
            </FormikForm>
          )}
        </Formik>
      </Modal>

      <Modal
        show={confirmState.show}
        onHide={() => {
          setRejectReason("");
          setConfirmState({ ...confirmState, show: false });
        }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Action</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-0 fs-5">{confirmState.message}</p>
          {confirmState.status === "Reject" ||
            confirmState.action === "delete" ? (
            <div className="mt-3">
              <label className="form-label fw-bold">
                Reason for{" "}
                {confirmState.action === "delete" ? "deletion" : "rejection"}
                <span className="text-danger">*</span>
              </label>
              <textarea
                className="form-control"
                rows={3}
                placeholder="Enter reason..."
                value={rejectReason}
                onChange={(e) => setRejectReason(e.target.value)}
              />
            </div>
          ) : (
            ""
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setRejectReason("");
              setConfirmState({ ...confirmState, show: false });
            }}
          >
            Cancel
          </Button>
          <Button
            variant={
              confirmState.action === "delete" ||
                confirmState.status === "Reject"
                ? "danger"
                : "primary"
            }
            style={
              confirmState.action !== "delete" &&
                confirmState.status !== "Reject"
                ? {
                  backgroundColor: "#E5484D",
                  borderColor: "#FFE4E6",
                  color: "white",
                }
                : {}
            }
            onClick={confirmActionHandler}
          >
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={limitModal}
        onHide={() => {
          setLimitModal(false);
          setAdsLimit("");
        }}
        centered
      >
        <Modal.Header closeButton style={{ backgroundColor: "#FFE4E6" }}>
          <Modal.Title>Set Ads Limit</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="mb-3">
            <label className="form-label fw-semibold">
              Maximum Ads Allowed
            </label>
            <input
              type="number"
              min="1"
              className="form-control"
              placeholder="Enter ads limit"
              value={adsLimit}
              onChange={(e) => setAdsLimit(e.target.value)}
            />
          </div>
        </Modal.Body>

        <Modal.Footer style={{ backgroundColor: "#FFE4E6" }}>
          <Button
            variant="secondary"
            onClick={() => {
              setLimitModal(false);
              setAdsLimit("");
            }}
          >
            Cancel
          </Button>

          <Button
            style={{
              backgroundColor: "#E5484D",
              borderColor: "#E5484D",
            }}
            onClick={handleSaveLimit}
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showExportModal}
        onHide={() => setShowExportModal(false)}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "#E5484D" }}>Export Ads Data</Modal.Title>
        </Modal.Header>

        <Formik
          initialValues={{
            startDate: startDate || "",
            endDate: endDate || "",
            exportType: exportType || "excel",
            adType: adType || "",
            expireStatus: expiry || "",
            furnishedType: "",
            minPrice: "",
            maxPrice: "",
            bedroom: "",
            bathroom: "",
          }}
          enableReinitialize
          validationSchema={ExportSchema}
          onSubmit={handleExportCSV}
        >
          {({ errors, touched, isSubmitting, values }) => {
            const today = new Date().toISOString().split("T")[0];

            return (
              <FormikForm>
                <Modal.Body>
                  <div className="row g-3">
                    <div className="col-md-12">
                      <label className="form-label fw-bold">Export Format</label>
                      <Field
                        as="select"
                        name="exportType"
                        className="form-select shadow-sm"
                        style={{ borderRadius: "0.5rem", borderColor: "#E5484D" }}
                      >
                        <option value="excel">Excel (.xlsx)</option>
                        <option value="csv">CSV (.csv)</option>
                      </Field>
                    </div>

                    <div className="col-md-12">
                      <label className="form-label fw-bold">
                        Location <span className="text-muted fw-normal">(Optional)</span>
                      </label>
                      <LocationSearchDropdown
                        value={exportLocationText}
                        onChange={setExportLocationText}
                        onSelect={(locationData) => {
                          setExportLocationText(locationData.name);
                          const lat = locationData.location?.coordinates?.[1];
                          const long = locationData.location?.coordinates?.[0];
                          setExportCoordinates({ lat, long });
                        }}
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label fw-bold">
                        Start Date <span className="text-danger">*</span>
                      </label>
                      <Field
                        type="date"
                        name="startDate"
                        max={today}
                        style={{ borderRadius: "0.5rem", borderColor: "#E5484D" }}
                        className={`form-control shadow-sm ${errors.startDate && touched.startDate ? "is-invalid" : ""
                          }`}
                      />
                      <ErrorMessage
                        name="startDate"
                        component="div"
                        className="invalid-feedback"
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label fw-bold">
                        End Date <span className="text-danger">*</span>
                      </label>
                      <Field
                        type="date"
                        name="endDate"
                        min={values.startDate || undefined}
                        max={today}
                        style={{ borderRadius: "0.5rem", borderColor: "#E5484D" }}
                        className={`form-control shadow-sm ${errors.endDate && touched.endDate ? "is-invalid" : ""
                          }`}
                      />
                      <ErrorMessage
                        name="endDate"
                        component="div"
                        className="invalid-feedback"
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label fw-bold">Ad Type</label>
                      <Field
                        as="select"
                        name="adType"
                        className="form-select shadow-sm"
                        style={{ borderRadius: "0.5rem", borderColor: "#E5484D" }}
                      >
                        <option value="">All</option>
                        <option value="Flat">Flat</option>
                        <option value="Flatmate">Flatmate</option>
                      </Field>
                    </div>

                    <div className="col-md-6">
                      <label className="form-label fw-bold">Listing Status</label>
                      <Field
                        as="select"
                        name="expireStatus"
                        className="form-select shadow-sm"
                        style={{ borderRadius: "0.5rem", borderColor: "#E5484D" }}
                      >
                        <option value="">All</option>
                        <option value="active">Active</option>
                        <option value="expire">Expired</option>
                      </Field>
                    </div>

                    <div className="col-md-6">
                      <label className="form-label fw-bold">Furnished Type</label>
                      <Field
                        as="select"
                        name="furnishedType"
                        className="form-select shadow-sm"
                        style={{ borderRadius: "0.5rem", borderColor: "#E5484D" }}
                      >
                        <option value="">All</option>
                        <option value="Fully Furnished">Fully Furnished</option>
                        <option value="Semi Furnished">Semi Furnished</option>
                        <option value="Unfurnished">Unfurnished</option>
                      </Field>
                    </div>

                    <div className="col-md-6">
                      <label className="form-label fw-bold">Min Price</label>
                      <Field
                        type="number"
                        name="minPrice"
                        placeholder="e.g. 5000"
                        style={{ borderRadius: "0.5rem", borderColor: "#E5484D" }}
                        className={`form-control shadow-sm ${errors.minPrice && touched.minPrice ? "is-invalid" : ""
                          }`}
                      />
                      <ErrorMessage
                        name="minPrice"
                        component="div"
                        className="invalid-feedback"
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label fw-bold">Max Price</label>
                      <Field
                        type="number"
                        name="maxPrice"
                        placeholder="e.g. 50000"
                        style={{ borderRadius: "0.5rem", borderColor: "#E5484D" }}
                        className={`form-control shadow-sm ${errors.maxPrice && touched.maxPrice ? "is-invalid" : ""
                          }`}
                      />
                      <ErrorMessage
                        name="maxPrice"
                        component="div"
                        className="invalid-feedback"
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label fw-bold">Bedroom</label>
                      <Field
                        as="select"
                        name="bedroom"
                        className="form-select shadow-sm"
                        style={{ borderRadius: "0.5rem", borderColor: "#E5484D" }}
                      >
                        <option value="">All</option>
                        <option value="Shared">Shared</option>
                        <option value="Private">Private</option>
                      </Field>
                    </div>

                    <div className="col-md-6">
                      <label className="form-label fw-bold">Bathroom</label>
                      <Field
                        as="select"
                        name="bathroom"
                        className="form-select shadow-sm"
                        style={{ borderRadius: "0.5rem", borderColor: "#E5484D" }}
                      >
                        <option value="">All</option>
                        <option value="Shared">Shared</option>
                        <option value="Private">Private</option>
                      </Field>
                    </div>
                  </div>
                </Modal.Body>

                <Modal.Footer>
                  <Button
                    variant="secondary"
                    onClick={() => setShowExportModal(false)}
                    disabled={exportLoading || isSubmitting}
                    style={{ borderRadius: "0.5rem" }}
                  >
                    Cancel
                  </Button>

                  <Button
                    type="submit"
                    disabled={exportLoading || isSubmitting}
                    className="shadow-sm"
                    style={{
                      borderRadius: "0.5rem",
                      backgroundColor: values.exportType === "excel" ? "#21a366" : "#E5484D",
                      borderColor: values.exportType === "excel" ? "#21a366" : "#E5484D",
                    }}
                  >
                    {exportLoading || isSubmitting ? "Exporting..." : values.exportType === "excel" ? "Export Excel" : "Export CSV"}
                  </Button>
                </Modal.Footer>
              </FormikForm>
            );
          }}
        </Formik>
      </Modal>
    </div>
  );
};

export default Listing;
